<template>
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }, { name: 'アカウント管理', pathName: 'settingAccounts' }]"
        :title="'アカウント'+ formTypeLabel"
        data-test="title"
      />
      <p>下記の項目を入力してください。</p>
      <form-item
        v-model="staffName"
        :form-label-class-name="'pega-form-label-account'"
      >
        <template #label>
          氏名
          <small>(25文字以内)</small>
        </template>
      </form-item>
      <form-item
        v-model="tel"
        :form-label-class-name="'pega-form-label-account'"
      >
        <template #label>
          TEL
          <small>(任意：50文字以内)</small>
        </template>
      </form-item>
      <form-item
        v-model="email"
        label="メールアドレス"
        :form-label-class-name="'pega-form-label-account'"
      />
      <form-item
        :value="loginIdLabel"
        label="ログインID"
        tag="label"
        type=""
        :form-label-class-name="'pega-form-label-account'"
      />
      <form-item
        v-model="authentication"
        :class-name="isLengthValidationAuthentication ? 'is-invalid-input certification-number-length' : 'certification-number-length'"
        data-test="authentication-invalid"
        :form-label-class-name="'pega-form-label-account'"
      >
        <template #label>
          認証番号
          <small>{{ authenticationValidLabel }}</small>
        </template>
        <template #error>
          <template v-for="(error, i) in authenticationValidationList">
            <validation-label
              v-if="error.isShow"
              :key="i"
              :data-test="`error-`+i"
              :label="error.message"
            />
          </template>
        </template>
      </form-item>
      <form-item-group
        v-model="permissions"
        :disabled="!isGeneral"
        :options="permissionOptions"
        :form-label-class-name="'pega-form-label-account'"
      >
        <template #label>
          操作権限
          <small>(任意)</small>
        </template>
      </form-item-group>
      <form-item-group
        v-model="receivableMailTypes"
        :disabled="checkId"
        :options="receivableMailTypeOptions"
        :form-label-class-name="'pega-form-label-account'"
        :mail-flag="checkId"
      >
        <template #label>
          メール受信設定&nbsp;
          <small>(任意)</small>
        </template>
      </form-item-group>
      <form-button-area>
        <form-confirm-button
          button-class="pega-width-auto"
          :is-disabled="isDisabled"
          :submit-label="submitLabel"
          data-test="confirm-button"
          @submit-event="onRegisterClick"
        />
      </form-button-area>
    </div>
  </div>
</template>

<style>
.certification-number-length {
  width: 5em;
}
</style>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import FormItem from '@/components/atoms/FormItem'
import FormItemGroup from '@/components/atoms/FormItemGroup'
import ValidationLabel from '@/components/atoms/ValidationLabel'
import FormButtonArea from '@/components/atoms/FormButtonArea'
import FormConfirmButton from '@/components/atoms/FormConfirmButton'
import { mapGetters } from 'vuex'

export default {
  components: {
    SettingHeader,
    FormItem,
    FormItemGroup,
    ValidationLabel,
    FormButtonArea,
    FormConfirmButton
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      staffName: '',
      tel: '',
      email: '',
      loginId: '',
      authentication: '',
      isGeneral: true,
      permissions: [],
      receivableMailTypes: []
    }
  },
  computed: {
    isLengthValidationAuthentication () {
      return this.authentication.length && this.authentication.length !== 4
    },
    loginIdLabel () {
      return this.loginId ? this.loginId : '※ログインIDは登録後に自動付与されます。'
    },
    ...mapGetters({
      permissionOptions: 'optionalPermissionsMaster',
      receivableMailTypeOptions: 'receivableMailTypesMaster'
    }),
    isDisabled () {
      return !this.staffName ||
      !this.email ||
      this.isLengthValidationAuthentication ||
      (!this.isGeneral && !this.authentication)
    },
    formTypeLabel () {
      return this.id ? '編集' : '登録'
    },
    checkId () {
      return !!this.loginId && this.isGeneral
    },
    submitLabel () {
      return this.id ? 'この内容でアカウントを編集する' : 'この内容でアカウントを登録し、ID／仮PWを送信する'
    },
    authenticationValidLabel () {
      return this.isGeneral ? '(任意：4桁)' : '(4桁)'
    },
    authenticationValidationList () {
      return [
        {
          isShow: this.isLengthValidationAuthentication,
          message: '4桁で入力してください'
        }
      ]
    }
  },
  created () {
    this.id && this.fetchStaff()
  },
  methods: {
    onRegisterClick () {
      this.$emit(
        'submit',
        {
          staffName: this.staffName,
          tel: this.tel,
          email: this.email,
          authentication: this.authentication,
          permissionIds: this.permissions,
          receivableMailTypeIds: this.receivableMailTypes
        }
      )
    },
    fetchStaff () {
      this.$http.secured.get(`/account/edit/settings/staff/${this.id}`)
        .then(response => {
          this.$set(this, 'staffName', response.data.staffName)
          this.$set(this, 'tel', response.data.tel)
          this.$set(this, 'email', response.data.email)
          this.$set(this, 'loginId', response.data.loginId)
          this.$set(this, 'authentication', response.data.authentication)
          this.$set(this, 'isGeneral', response.data.isGeneral)
          this.$set(this, 'permissions', response.data.permissions.map(permission => permission.id))
          this.$set(this, 'receivableMailTypes', response.data.receivableMailTypes.map(receivableMailType => receivableMailType.id))
        })
    }
  }
}
</script>
